<template>
  <div class="container">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'" ref="header"></Header>
    <!-- content(s) -->
    <div id="content" style="padding-bottom: 72px;">
      <div class="progress uiAct" role="img" aria-label="총 3단계 중 2단계 결제정보입력 진행중">
        <ol aria-hidden="true">
          <li><span>동의 및 본인인증</span></li>
          <li class="on"><span>결제정보입력</span></li>
          <li><span>계약서작성</span></li>
        </ol>
      </div>

      <section class="hr">
        <div class="titArea mt0">
          <h2 class="titH3 normal">배송정보사항을 확인해주세요.</h2>
        </div>

        <span class="label">설치/배송예상일</span>
        <div class="setHalf readonly">
          <datepicker
            :value="date"
            :format="format"
            :input-class="inputClass"
            :language="lang"
            :disabled-dates="disabledDate"
            v-model="installReqDate"
          ></datepicker>
        </div>
        <span class="label">배송연락처</span>
        <span class="singleIpt">
          <input type="checkbox" class="ipt notDel uiAct" name="" id="chk1_1" value="" v-model="useConInfoCheck" />
          <label for="chk1_1">주문자의 휴대폰번호와 연락 받을 번호가 다릅니다.</label>
        </span>

        <div class="formArea">
          <span class="label">이름</span>
          <div class="iptWrap">
            <input type="text" id="ipt4" class="ipt uiAct" title="이름 입력" value="" v-model="userName" :disabled="disableFlag" />
            <button class="btnIco_del" tabindex="-1">
              <span class="blind">해당 필드 입력값 삭제</span>
            </button>
          </div>

          <span class="label">휴대폰번호</span>
          <input type="tel" id="ipt5" class="ipt notDel uiAct" title="휴대폰번호 입력" value="" v-model="cellNum" :disabled="disableFlag" />
        </div>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="goNoticePage">
            다음
          </button>
        </div>
      </section>
      <MessagePop v-if="messagePop" @close="messagePop = false">
        <p v-html="popMsg"></p>
      </MessagePop>
      <ConfirmPop @cancel="cancel" @confirm="confirm" @close="close" v-if="confirmPop">
        <p v-html="popMsg"></p>
      </ConfirmPop>
      <FindAddr v-if="findAddr" @callback="selectAddr" @close="popupClose"></FindAddr>
    </div>
    <!-- content(e) -->
  </div>
</template>

<script>
//import * as customjs from '@/../static/js/m.front.js';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import { INFO_CHECK, GO_HOME } from '@/store/message.type.js';
import MessagePop from '@/components/popup/MessagePop';
import ApiService from '@/common/api.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { isEmpty } from '@/common/common.function';

export default {
  components: {
    Datepicker,
    MessagePop,
    ConfirmPop,
  },
  mounted: function() {
    this.$cookies.remove('friendObj');
    console.log(this.$route.params);
    ApiService.service('GET', '/product/' + this.prodCode, {
      params: '',
    }).then(({ data }) => {
      this.prodDetail = data.result.productDetail;
      this.defaultDate();
    });

    //document.getElementsByClassName('goTop')[0].remove();
  },
  // mixins: [popup],
  data: function() {
    return {
      // datepicker 관련
      date: new Date(),
      format: 'yyyy-MM-dd',
      inputClass: 'ipt date notDel uiAct',
      //calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      flag: true,
      disabledDate: {
        to: new Date(),
      },

      // 이전 step의 입력 정보
      paramObj: this.$route.params.paramObj,
      prodCode: this.$route.params.prodCode,
      userName: this.$route.params.paramObj.request.conOrderInfo.customerName,
      cellNum: this.$route.params.paramObj.request.conOrderInfo.cellNum,

      prodDetail: [],

      installReqDate: null,

      // 기타
      useConInfoCheck: false,
      disableFlag: true,

      // 팝업 관련
      messagePop: null,
      findAddr: null,
      popMsg: null,
      confirmPop: null,

      // 신용조회 결과
      approvalYN: null,
      tightenYN: null,
      rejectYN: null,
      creditErrorYN: null,
      creditCompletedYN: null,
    };
  },
  watch: {
    useConInfoCheck() {
      this.disableFlag = !this.useConInfoCheck;
      if (this.useConInfoCheck) {
        this.userName = null;
        this.cellNum = null;
      } else {
        this.userName = this.$route.params.paramObj.request.conOrderInfo.customerName;
        this.cellNum = this.$route.params.paramObj.request.conOrderInfo.cellNum;
      }
    },
  },
  methods: {
    getInstallDate: function() {
      let today = new Date();
      today.setDate(today.getDate() - 1);
      return today;
    },
    defaultDate: function() {
      let today = new Date();
      let mday = isEmpty(this.prodDetail.deliveryDaysNum) ? 3 : new Number(this.prodDetail.deliveryDaysNum);
      today.setDate(today.getDate() + mday);
      this.date = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
      this.installReqDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
      console.log(this.date);
      today = new Date();
      today.setDate(today.getDate() + (mday - 1));
      this.disabledDate.to = today;
    },
    goNoticePage() {
      let inputFlag = false;
      if (this.installReqDate == null || this.installReqDate == '') {
        inputFlag = true;
      }

      if (this.useConInfoCheck && (this.userName == null || this.userName == '')) {
        inputFlag = true;
      }

      if (this.useConInfoCheck && (this.cellNum == null || this.cellNum == '')) {
        inputFlag = true;
      }

      if (inputFlag) {
        this.popMsg = INFO_CHECK;
        this.messagePop = true;
        return false;
      }

      /*let year = this.installReqDate.getFullYear();
        let month = String(this.installReqDate.getMonth() - 1);
        let day = String(this.installReqDate.getDate());

        month = month.length == 1 ? '0' + month : month;
        day = day.length == 1 ? '0' + day : day;
      */
      let sd = '';
      if (typeof this.installReqDate == 'string') {
        sd = this.installReqDate;
      } else {
        sd =
          this.installReqDate.getFullYear() +
          '-' +
          ('0' + (this.installReqDate.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + this.installReqDate.getDate()).slice(-2);
      }

      let installInfo = this.paramObj.request.installInfo;
      installInfo.installReqDate = sd;

      //TODO : 아래 코드는 어디서 사용되는 코드인지 확인 필요. installCellNum, installUserName
      if (this.useConInfoCheck) {
        installInfo.installCellNum = this.cellNum;
        installInfo.installUserName = this.userName;
      } else {
        installInfo.installCellNum = this.paramObj.request.conOrderInfo.cellNum;
        installInfo.installUserName = this.paramObj.request.conOrderInfo.customerName;
      }
      //TODO : 아래 코드 용도 확인 필요 2020-10-29
      this.paramObj.request.orderCommInfo.orderStatus = 'RSTA00RP';

      // 신용조회 확인
      let creditParam = new Object();
      let creditRequest = new Object();
      creditRequest.creditKey = this.paramObj.request.orderCommInfo.creditKey;
      creditParam.request = creditRequest;
      creditParam.serviceType = 'app';

      // TODO 테스트용 이후 신용조회 결과 체크 기능 정상동작 후 원복
      // let flag = false;

      ApiService.service('PUT', '/order/credit', creditParam)
        .then(({ data }) => {
          console.log('test :: ' + JSON.stringify(data));

          this.approvalYN = data.result.approvalYN;
          this.tightenYN = data.result.tightenYN;
          this.rejectYN = data.result.rejectYN;
          this.creditErrorYN = data.result.errorYN;
          this.creditCompletedYN = data.result.completeYN;

          if (data.result.completeYN == 'Y' && data.result.approvalYN == 'Y') {
            //flag = true;
          }
          this.paramObj.request.orderCommInfo.requestKey = this.paramObj.request.orderCommInfo.creditKey;

          if (this.creditCompletedYN == 'N') {
            this.popMsg = '신용조회가 아직 끝나지 않았습니다.';
            this.messagePop = true;
          } else {
            this.$refs.header.loadingStart(); // 로딩시작
            ApiService.service('POST', '/order/rental', this.paramObj)
              .then(({ data }) => {
                if (data.isSucceed) {
                  this.paramObj.request.orderCommInfo.orderId = data.result.orderId;
                  let params = {
                    af_method: '회원',
                    af_revenue: this.prodDetail.saleAmount,
                    af_price: this.prodDetail.rentalAmount,
                    af_content: this.prodDetail.rentalPeriodNm,
                    af_content_id: this.paramObj.request.orderCommInfo.productCode,
                    af_order_id: this.paramObj.request.orderCommInfo.orderId,
                    af_content_type: '렌탈',
                    af_used_rental: data.result.rentalUsedYn,
                  };

                  if (this.approvalYN == 'Y') {
                    params.af_result = '통과';
                  } else {
                    params.af_result = '거절';
                    delete params.af_revenue;
                  }

                  window.appsFlyer('af_rental', params);

                  if (this.approvalYN == 'Y') {
                    //const appsFlyerParams = JSON.stringify(params);
                    //window.appsFlyer('af_rental', params);
                    this.$router.push({
                      name: 'memberStep5',
                      params: { paramObj: this.paramObj },
                    });
                  } else if (this.rejectYN == 'Y') {
                    this.$router.push('/order/rental/rentalReject');
                  } else if (this.tightenYN == 'Y' || this.creditErrorYN == 'Y') {
                    this.$router.push('/order/rental/rentalFail');
                  }
                } else if (data.error != '') {
                  this.popMsg = data.error;
                  this.messagePop = true;
                }
              })
              .catch(({ response }) => {
                console.log('error : ' + response);
              })
              .finally(() => {
                this.$refs.header.loadingEnd(); // 로딩끝
              });
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    rental: function() {
      //장바구니에 담을건지 ConfirmPop 노출
      this.popMsg = GO_HOME;
      this.confirmPop = true;
    },
    cancel: function() {
      this.confirmPop = false;
    },
    close: function() {
      this.confirmPop = false;
    },
    confirm: function() {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.replace('/');
    },
  },
};
</script>
